import { Application } from "@hotwired/stimulus"

const application = Application.start()

// Configure Stimulus development experience (local only; keeps production consoles clean)
application.debug = ["localhost", "127.0.0.1", "[::1]"].includes(window.location.hostname)
window.Stimulus   = application

export { application }
